import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useClaimTypesApi } from "../../../http/claimTypes/api";
import ModalDialog from "../../ui/ModalDialog";

type DeleteClaimTypeDialogProps = {
  claimTypeId: string;
  onClose: () => void;
};

const DeleteClaimTypeDialog: FC<DeleteClaimTypeDialogProps> = ({ claimTypeId, onClose }) => {
  const i18n = useI18n();
  const claimTypesApi = useClaimTypesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.claimTypes.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            claimTypesApi
              .deleteAdminClaimType(claimTypeId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.claimTypes.questions.delete}
    </ModalDialog>
  );
};

export default DeleteClaimTypeDialog;
